import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { BxBreadcrumb, BxBreadcrumbsComponent } from '@beyonnex/bx-angular-ui';
import { Content, DynamicViewDirective } from '@ngneat/overview';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'bxi-page',
  imports: [DynamicViewDirective, BxBreadcrumbsComponent, TranslatePipe],
  templateUrl: './page.component.html',
  host: {
    class: 'w-full flex flex-col',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageComponent {
  title = input.required();
  breadcrumbOptions = input.required<BxBreadcrumb[]>();
  supportingTitle = input<string>();
  readonly headerContent = input<Content>();
}
